var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropdown_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8375 4.99875C13.6881 4.99824 13.5405 5.03121 13.4055 5.09524C13.2705 5.15927 13.1516 5.25273 13.0575 5.36875L8.22749 11.3687C8.08041 11.5477 8 11.7721 8 12.0037C8 12.2354 8.08041 12.4598 8.22749 12.6387L13.2275 18.6387C13.3972 18.843 13.6411 18.9714 13.9056 18.9958C14.17 19.0201 14.4333 18.9385 14.6375 18.7687C14.8417 18.599 14.9701 18.3551 14.9945 18.0907C15.0189 17.8262 14.9372 17.563 14.7675 17.3587L10.2975 11.9987L14.6175 6.63875C14.7398 6.49196 14.8174 6.31322 14.8413 6.12367C14.8652 5.93413 14.8343 5.7417 14.7522 5.56917C14.6702 5.39665 14.5404 5.25123 14.3783 5.15014C14.2162 5.04905 14.0285 4.99652 13.8375 4.99875Z",
    fill: "#eb2426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow3);
export default __webpack_public_path__ + "static/media/dropdown_arrow3.bdd68432882a5ec7d28b0569404af9c2.svg";
export { ForwardRef as ReactComponent };